// skipcq: JS-W1028
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import BeerTagChips from '../brewhouse/BeerTagChips';
import TapRatingBar from '../ratings/TapRatingBar';

function BeerProfileRatingPanel({
  label,
  rating,
  tags,
  unratedLabel,
  hideIconsWhenUnrated = false,
  showTagCounts = true,
}) {
  return (
    <Box
      sx={{
        py: 1.5,
        '&:not(:last-of-type)': {
          borderBottom: 1,
          borderColor: 'divider',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          flexWrap: 'nowrap',
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600, minWidth: 96, flexShrink: 0 }}>
          {label}
        </Typography>
        <Box sx={{ flexShrink: 0 }}>
          <TapRatingBar
          rating={rating}
          size="compact"
          showNumeric
          showUnratedLabel
          unratedLabel={unratedLabel}
          hideIconsWhenUnrated={hideIconsWhenUnrated}
          />
        </Box>
      </Box>
      <BeerTagChips tags={tags} showCount={showTagCounts} />
    </Box>
  );
}

BeerProfileRatingPanel.propTypes = {
  label: PropTypes.string.isRequired,
  rating: PropTypes.number,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    }),
  ).isRequired,
  unratedLabel: PropTypes.string,
  hideIconsWhenUnrated: PropTypes.bool,
  showTagCounts: PropTypes.bool,
};

export default BeerProfileRatingPanel;
